import "../components/styles.css";
import React from "react";
import CalendarPicker from "../components/calendar-picker";
import Time from "../components/time";

export default function Hours({
  onSelectedDateFrom,
  dateFrom,
  dateTo,
  timeFrom,
  onSelectTimeFrom,
  timeTo,
  onSelectTimeTo,
  isDateToSameAsDateFrom,
  is24HoursFormat,
}) {
  return (
    <>
      <div className="check-in-out-container" id="hours-from-container">
        <CalendarPicker
          label={"From"}
          isStanAlone={false}
          onSelected={(value, str) => onSelectedDateFrom(value, str)}
          value={dateFrom}
          id="hours-calendar-from-component"
        />
        <Time
          label={"Time"}
          ampm={!is24HoursFormat}
          value={timeFrom}
          onChange={(value) => onSelectTimeFrom?.(value)}
          id="hours-time-from-component"
        />
      </div>
      <div className="check-in-out-container" id="hours-to-container">
        <CalendarPicker
          label={"To"}
          isStanAlone={false}
          isDisabled
          value={isDateToSameAsDateFrom ? dateFrom : dateTo}
          id="hours-calendar-to-component"
        />
        <Time
          label={"Time"}
          ampm={!is24HoursFormat}
          value={timeTo}
          onChange={(value) => onSelectTimeTo?.(value)}
          id="hours-time-to-component"
        />
      </div>
    </>
  );
}
